import { createContext, useEffect, useState } from "react";

export const GlobalContext = createContext([]);

const GlobalContextProvider = (props) => {
    
    const [windowSize, setWindowSize] = useState('');
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        window.addEventListener('resize', windowResize);
        if (window.innerWidth >= 1400){
            setWindowSize('xxl');
            setIsMobile(false);
        }
        else if (window.innerWidth >= 1200){
            setWindowSize('xl');
            setIsMobile(false);
        }
        else if (window.innerWidth >= 992){
            setWindowSize('lg');
            setIsMobile(false);
        }
        else if (window.innerWidth >= 768){
            setWindowSize('md');
            setIsMobile(false);
        }
        else if (window.innerWidth >= 576){
            setWindowSize('sm');
            setIsMobile(true);
        }
        else if (window.innerWidth < 576){
            setWindowSize('xs');
            setIsMobile(true);
        }

        return (() => {
            window.removeEventListener('resize', windowResize);
        })
    }, [])

    const windowResize = () => {
        if (window.innerWidth >= 1400){
            setWindowSize('xxl');
            setIsMobile(false);
        }
        else if (window.innerWidth >= 1200){
            setWindowSize('xl');
            setIsMobile(false);
        }
        else if (window.innerWidth >= 992){
            setWindowSize('lg');
            setIsMobile(false);
        }
        else if (window.innerWidth >= 768){
            setWindowSize('md');
            setIsMobile(false);
        }
        else if (window.innerWidth >= 576){
            setWindowSize('sm');
            setIsMobile(true);
        }
        else if (window.innerWidth < 576){
            setWindowSize('xs');
            setIsMobile(true);
        }
    }

    return(
        <GlobalContext.Provider value={{isMobile: isMobile, windowSize: windowSize}}>
        {props.children}
        </GlobalContext.Provider>
    );
}

export default GlobalContextProvider;